module.exports = __webpack_public_path__ + "static/media/12.bd8bdb0f.jpeg";